export const decodeHtmlEntities = (html: string) => {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = html;
    return textarea.value;
};

export const addSpacesToEnumValue = (value: string): string => value?.replace(/([a-z])([A-Z])/g, "$1 $2");

export const removeNonNumeric = (inputString: string) => inputString.toString().replace(/\D/g, '');
